import { QueryClient } from "@tanstack/react-query";
import { IProposalTemplate } from "../components/job/types";
import { toTitleCase } from "./utils";

export function invalidateQueries(queryClient: QueryClient, keys: any[]) {
  const queries = Array.isArray(keys) ? keys : [keys];
  queries.forEach((q: any) => {
    queryClient.invalidateQueries({
      queryKey: [q],
    });
  });
}

export function getOptionList(templates: IProposalTemplate[]) {
  const groups = templates.reduce(
    (acc: Set<string>, { group }: IProposalTemplate) => {
      const tempGroups = group?.split(",") || [];
      tempGroups.forEach((g) => acc.add(g.toLocaleLowerCase().trim()));
      return acc;
    },
    new Set<string>(),
  );

  const sortedGroups = Array.from(groups)
    .map(toTitleCase)
    .sort((a, b) => a.localeCompare(b));

  return sortedGroups;
}

export function formatFileSize(fileSizeBytes: any): string {
  const bytes = Number(fileSizeBytes || 0);
  if (!Number.isFinite(bytes) || bytes <= 0) {
    return "";
  }

  if (bytes < 1024) {
    return `${bytes} B`;
  }
  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(1)} KB`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function canPreviewDocument(document: {
  mime_type?: string;
  original_name?: string;
  path?: string;
}): boolean {
  const mimeType = (document?.mime_type || "").toLowerCase();
  if (mimeType === "application/pdf" || mimeType.startsWith("image/")) {
    return true;
  }

  const fileName = (
    document?.original_name ||
    document?.path ||
    ""
  ).toLowerCase();
  return /(\.pdf|\.png|\.jpg|\.jpeg|\.gif|\.webp|\.bmp|\.svg)$/i.test(fileName);
}
